module.exports = __webpack_public_path__ + "media/images/img-pb-optima-1a535753932a0bbc36a4d82932df03bc.png";